<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <navbar></navbar>
    </div>
    <!-- 面包屑导航 -->
    <div class="Box">
      <div class="table_tab">
        <div class="inquiry">
          <div class="headerbox">
            <div class="header">佣金统计</div>
          </div>
          <div class="table">
            <matrix-table
              :dataList="commission.page.list"
              :config="commission.config"
              :loading="commission.loading"
            ></matrix-table>
          </div>
        </div>
        <div class="inquiryTab">
          <div class="inquiryTab_header">
            <div class="tabTitle">月度统计</div>
            <div class="tabBtn" @click="toDetail">佣金明细</div>
          </div>
          <div class="table">
            <matrix-table
              :dataList="manage.page.list"
              :config="manage.config"
              @receiveData="handlerEmitFanStr"
              :loading="manage.loading"
            ></matrix-table>
            <div class="page">
              <div class="block">
                <el-pagination
                  @size-change="onSizeChange"
                  @current-change="onCurrentChange"
                  :current-page="manage.page.pageNo"
                  :page-size="manage.page.pageSize"
                  :page-sizes="[3, 5, 10, 20, 50]"
                  layout="total, sizes,prev, pager, next"
                  :total="manage.page.totalNum"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MatrixTable from './components/MatrixTable.vue'
import common from './mixins/common'
import navbar from '@/components/navbar.vue'
export default {
  mixins: [common],
  watch: {

  },
  components: {
    MatrixTable,
    navbar
  },
  data () {
    return {
      commission: {
        loading: false,
        page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1 }, // 员工业绩统计(XX年XX月)
        sortObj: { prop: 'marketPrice', order: 'descending' }, // 排序
        config: [
          { prop: 'totalAmount', label: '佣金总数' },
          // { prop: 'effectiveAmount', label: '账号可用佣金' },
          { prop: 'awaitAmount', label: '冻结中' },
          // { prop: 'applyingAmount', label: '申请提现中' },
          // { prop: 'appliedAmount', label: '已提现' },
          { prop: 'vipAmount', label: '分享身份佣金总数' },
          { prop: 'giftPackageAmount', label: '分享礼包佣金总数' },
          { prop: 'goodsAmount', label: '分享商品佣金总数' }
        ]
      },
      manage: {
        loading: false,
        page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1 }, // 员工业绩统计(XX年XX月)
        sortObj: { prop: 'marketPrice', order: 'descending' }, // 排序
        config: [
          { prop: 'monthDate', label: '佣金月份' },
          { prop: 'totalAmount', label: '佣金总数' },
          // { prop: 'effectiveAmount', label: '账号可用佣金' },
          { prop: 'awaitAmount', label: '冻结中' },
          // { prop: 'applyingAmount', label: '申请提现中' },
          // { prop: 'appliedAmount', label: '已提现' },
          { prop: 'vipAmount', label: '分享身份佣金总数' },
          { prop: 'giftPackageAmount', label: '分享礼包佣金总数' },
          { prop: 'goodsAmount', label: '分享商品佣金总数' },
          { prop: 'updatedTime', label: '操作', slot: 'details' }
        ]
      },
      parArray: []
    }
  },
  mounted () {

  },
  created () {
    // this.fetchData()
    this.getStatisticsDataList()
    this.getDataList()
    // 权限设定判断
    this.limits = JSON.parse(sessionStorage.getItem('limit'))
    const params = this.limits.buttonTreeDto.filter(
      (item) => item.menuCode === 'categoryManage'// 菜单管理里面的菜单编码
    )
    params[0].buttonList.forEach((item) => {
      this.parArray.push(item.code)
    })
    console.log(this.parArray)
    // 权限设定判断
    document.onkeydown = (e) => {
      const key = window.event.keyCode
      if (key == 13) {
        this.searchEvent()
      }
    }
  },
  beforeRouteLeave (to, form, next) {
    document.onkeydown = null
    next()
  },

  methods: {
    getStatisticsDataList () {
      this.commission.loading = true
      const params = {}
      this.commission.page.list = []
      this.$api.matrixStatiticsPlatform(params).then((res) => {
        if (res.code === 0) {
          this.commission.loading = false
          this.commission.page.list.push(res.data)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getDataList () {
      this.manage.loading = true
      const data = {
        pageNo: this.manage.page.pageNo,
        pageSize: this.manage.page.pageSize
      }
      this.$api.matrixMonthPageListPlatform(data).then((res) => {
        if (res.code === 0) {
          this.manage.loading = false
          console.log(res, 'rwerwer')
          res.data.list.forEach((item) => {
            item.appliedAmount = item.appliedAmount.toFixed(2)
            item.applyingAmount = item.applyingAmount.toFixed(2)
            item.awaitAmount = item.awaitAmount.toFixed(2)
            item.effectiveAmount = item.effectiveAmount.toFixed(2)
            item.giftPackageAmount = item.giftPackageAmount.toFixed(2)
            item.goodsAmount = item.goodsAmount.toFixed(2)
            item.totalAmount = item.totalAmount.toFixed(2)
            item.vipAmount = item.vipAmount.toFixed(2)
          })
          this.manage.page.list = res.data.list
          this.manage.page.totalNum = res.data.totalNum
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    toDetail () {
      this.$router.push({
        path: '/matrix/commissionDetail',
      })
    },
    handlerEmitFanStr (e) {
      if (e.type === 'details') {
        this.$router.push({
          path: '/matrix/commissionDetails',
          query: {
            monthDate: e.row.monthDate
          }
        })
      }
      console.log(e)
    },
    onSizeChange (sizeChange) {
      this.manage.page.pageNo = 1
      this.manage.page.currentPage = 1
      this.manage.page.pageSize = sizeChange
      this.getDataList()
    },
    onCurrentChange (currentChange) {
      this.manage.page.pageNo = currentChange
      this.getDataList()
    },
    fetchData (type) {
      this.manage.loading = true
      if (type === 'reset') {
        this.manage.page.pageNo = 1
        this.manage.page.pageSize = 10
        this.manage.page.currentPage = 1
      }
      let params = {
        pageNo: this.manage.page.pageNo,
        pageSize: this.manage.page.pageSize
      }
      if (type === 'search') {
        this.manage.page.currentPage = 1
        this.manage.page.pageNo = 1
        params.pageNo = 1
        params = Object.assign({}, params, this.search)
        // 去除字符串 前后 空格
        for (const item in params) { if (typeof params[item] === 'string') { params[item] = params[item].trim() } }
      }
      this.$api.goodsPageList(params).then((res) => {
        if (res.code === 0) {
          this.manage.loading = false
          console.log(res, 'rewerwer')
          this.manage.page.list = res.data.list
          this.manage.page.totalNum = res.data.totalNum
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped lang="scss">
.tabBtn {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #ffffff;
  text-align: center;
  margin-top: 10px;
  cursor: pointer;
}
.Box {
  display: flex;
  justify-content: flex-start;
  width: 100%;

  .table_tab {
    width: 100%;
    margin-bottom: 50px;
  }
}
.table {
  border-radius: 5px;
  width: 100%;
}

.header {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
}

.inquiry {
  background: #fff;
  padding: 10px 20px 10px 20px;
  border-radius: 5px;
  .el-form {
    margin-top: 10px;
  }
}
.inquiryTab {
  background: #fff;
  padding: 10px 20px 20px 20px;
  border-radius: 5px;
  .el-form {
    margin-top: 10px;
  }
  margin-top: 20px;
  .inquiryTab_header {
    display: flex;
    justify-content: space-between;
    /deep/ .el-button {
      height: 40px;
    }
  }
}

/deep/.el-table__expand-icon > .el-icon {
  color: transparent;
}

.table {
  margin-top: 10px;
  border: 1px solid #e8eaec;
  border-radius: 0;
  /deep/ .el-input--suffix .el-input__inner {
    color: #000;
    width: 104px;
    box-shadow: none;
  }
  /deep/ .el-button {
    padding: 10px 13px;
  }
}

.page {
  text-align: right;
  width: 100%;
  background: #f5f5f5;
  padding-right: 30px;
  position: fixed;
  bottom: 0px;
  right: 0px;
  z-index: 5;

  span {
    font-size: 14px;
    color: #666;
    display: inline-block;
    margin-left: 10px;
  }
  .el-pagination {
    display: inline-block;
    vertical-align: middle;
  }
}
/deep/.el-table__row:hover {
  color: rgb(45, 125, 223);
}
/deep/.el-dialog__header {
  padding: 20px 20px 20px 20px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 25px;
  color: #333333;
}
/deep/.el-dialog {
  border-radius: 10px;
}
/deep/.el-dialog__headerbtn {
  top: 15px;
}
.headerbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.tabTitle {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #333333;
  opacity: 1;
  margin-top: 10px;
  margin-bottom: 20px;
}
/deep/.el-form-item__label {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

/deep/ .el-dialog__footer {
  margin-top: -20px;
  padding-top: 20px;
}
/deep/.el-table thead {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #333333;
  opacity: 1;
}

.btnClass {
  margin-top: 20px;
  display: flex;
  justify-content: right;
}
:deep(.avatar-uploader .el-upload) {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 90px;
  height: 90px;
  line-height: 90px;
  text-align: center;
}
.avatar {
  width: 90px;
  height: 90px;
  display: block;
}
</style>
